import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import type { FolderForestNode } from "owa-favorites-types";

const setPreviousNodeMutator: (previousNode?: FolderForestNode) => void = mutatorAction("setPreviousFolderForestNode", (previousNode?: FolderForestNode): void => {
    getStore().previousNode = previousNode ? { ...previousNode } : undefined;
});

export default function setPreviousNode(previousNode?: FolderForestNode): void {
    setPreviousNodeMutator(previousNode);
}
